import "./resourceText.css";
import Patient from "../resourceComponents/Patient/Patient";
import Condition from "../resourceComponents/Condition/Condition";
import AllergyIntolerance from "../resourceComponents/AllergyIntolerance/AllergyIntolerance";
import MedicationStatement from "../resourceComponents/MedicationStatement/MedicationStatement";
import List from "../resourceComponents/List/List";
import Encounter from "../resourceComponents/Encounter/Encounter";
import Observation from "../resourceComponents/Observation/Observation";
import Practitioner from "../resourceComponents/Practitioner/Practitioner";
import Appointment from "../resourceComponents/Appointment/Appointment";
import Coverage from "../resourceComponents/Coverage/Coverage";
import Organization from "../resourceComponents/Organization/Organization";
import DiagnosticReport from "../resourceComponents/DiagnosticReport/DiagnosticReport";
import Composition from "../resourceComponents/Composition/Composition";
import Procedure from "../resourceComponents/Procedure/Procedure";

const ResourceComponents = {
  Patient,
  Condition,
  AllergyIntolerance,
  MedicationStatement,
  List,
  Encounter,
  Observation,
  Practitioner,
  Appointment,
  Coverage,
  Organization,
  DiagnosticReport,
  Composition,
  Procedure,
};

const ResourceText = (props) => {
  const SelectedComponenet = ResourceComponents[props?.selectedResource];
  if (props.selectedResource) {
    return (
      <div>
        <SelectedComponenet
          getData={props?.extractResourceData}
          setResourceListData={props.setResourceListData}
          resourceListData={props.resourceListData}
        />
      </div>
    );
  }
};

export default ResourceText;
